export default {
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
    }
  },
  methods: {
    // 打开二维码
    openCode(type) {
      this.dialogVisible = true
      switch (type) {
        case 'wechat':
          this.dialogTitle = '官方微信'
          break;
        default:
          break;
      }
    },
    handleDialogConfirm() {
      this.dialogVisible = false
    },
    // 打开链接
    openLink(type) {
      switch (type) {
        case 'weibo':
          window.open('https://weibo.com/u/7568324675?topnav=1&wvr=6&topsug=1')
          break;
        case 'taptap':
          window.open('https://www.taptap.cn/app/208783')
          break;
        case 'hykb':
          window.open('https://www.3839.com/a/131247.htm')
          break;
        case 'bilibili':
          window.open('https://space.bilibili.com/1880441840')
          break;
        case 'xhs':
          window.open('https://www.xiaohongshu.com/user/profile/5dae73e40000000001005ab8')
          break;
        default:
          break;
      }
    },
  },
}